import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';

const IconLegal = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    aria-label="IconLegal"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="m11.585 10.088-4.574-4.57L8.544 3.98a1.1 1.1 0 0 0 .33-.8 1.09 1.09 0 0 0-.33-.798L6.49.33A1.08 1.08 0 0 0 5.698 0c-.3-.003-.589.109-.807.313L1.018 4.215a1.13 1.13 0 0 0-.328.806 1.08 1.08 0 0 0 .328.792l2.054 2.051a1.136 1.136 0 0 0 1.6 0l1.533-1.538 4.565 4.562a.57.57 0 0 0 .815 0 .6.6 0 0 0 .164-.4.52.52 0 0 0-.164-.4M7.493 10.857H.83a.56.56 0 0 0-.58.564.57.57 0 0 0 .165.407.53.53 0 0 0 .4.172h6.663a.54.54 0 0 0 .4-.164.56.56 0 0 0 .164-.415.55.55 0 0 0-.164-.392.52.52 0 0 0-.385-.172" />
  </svg>
);

const ForwardRef = /* #__PURE__ */ forwardRef(IconLegal);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
